export default "__VITE_ASSET__DQv026qs__ 640w, __VITE_ASSET__C95qSkhl__ 960w, __VITE_ASSET__Cs4QEGsQ__ 1280w, __VITE_ASSET__BQCGTThC__ 1920w";